import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { GetTransactionBO } from './transaction-menu-modal';

@Injectable({
  providedIn: 'root'
})
export class TransactionDataMenuService extends Subject<DataStateChangeEventArgs> {

  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent,
    public general: GeneralService) {
    super();
  }

  public executeTransactionMenu(state: GetTransactionBO): void {
    this.getAgencyList(state).subscribe(x => super.next(x));
  }

  getAgencyList(state?: GetTransactionBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/TransactionMenu/GetTransactionMenuList", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))


  }
}
